import { once } from 'js/lib/events'

export async function initFlashCounter($element) {
  const $flashContainer = $element.parents('.js-c-flash')
  const $counterElement = $element.find('.js-c-flash__countdown__counter')
  let counter = $element.data('counter')
  const interval = setInterval(() => {
    $counterElement.text((counter -= 1))

    if (counter <= 0) {
      $element.trigger('click')
    }
  }, 1000)

  once('click', $element.get(0), () => {
    window.clearInterval(interval)

    $flashContainer.fadeOut(() => {
      $flashContainer.remove()
    })
  })
}
